import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Divider } from 'primereact/divider';
import { verifyEmail } from '../../../actions';
import { Button } from 'primereact/button';


const EmailVerifySuccess = () => {

  const { search } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const verifyEmailState = useSelector(state => state.verifyEmailReducers);

  const parseQuery = query => {
    const queries = query.substring(1);
    const pairs = queries.split('&');
    const queryParams = {};
    pairs.forEach(pair => {
      const [key, value] = pair.split('=');
      queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    return queryParams;
  };

  const { token,username } = parseQuery(search);

  useEffect(() => {
    dispatch(verifyEmail({token:token,username:username}));
  }, []);

  return (
    <>
    {verifyEmailState?.status === 'success' &&
    <div className="rightside-container">
      <div className="rightside-body px-6">
        <div className='flex flex-column align-items-center'>
          <h3>Email Verification</h3>
          <span>Your email has been verified and can receive verification codes.</span>
          <Divider className='py-3' />
        </div>
        <div className="pt-2 lg:w-5 md:w-5 mx-auto">
          <div style={{ width: '150px', height: '150px'}} className="bg-green-500 border-circle flex justify-content-center align-items-center mx-auto">
            <i className="pi pi-check text-white" style={{ 'fontSize': '3em' }}></i>
          </div>
          <h2 className='text-center'>Success!</h2>
          <a href="/accountmanagement/oauth2/authorization/oracle"><Button label="Continue" className="mt-5 p-button-outlined p-button-info w-full py-3" /></a>
        </div>
      </div>
    </div>
    }
    {verifyEmailState?.status === 'fail' &&
    <div className="rightside-container">
      <div className="rightside-body px-6">
        <div className='flex flex-column align-items-center'>
          <h3>Email Verification</h3>
          <span>The link for validating your email has expired. To validate your email, go to Account Management, MFA and Request Update Email.</span>
          <Divider className='py-3' />
        </div>
        <div className="pt-2 lg:w-5 md:w-5 mx-auto">
          <div style={{ width: '150px', height: '150px'}} className="bg-orange-500 border-circle flex justify-content-center align-items-center mx-auto">
            <i className="pi pi-check text-white" style={{ 'fontSize': '3em' }}></i>
          </div>
          <h2 className='text-center'>Error!</h2>
          <a href="/accountmanagement/oauth2/authorization/oracle"><Button label="Continue" className="mt-5 p-button-outlined p-button-info w-full py-3"/></a>
        </div>
      </div>
    </div>

    }
    </>
  );
}

export default EmailVerifySuccess;